import moment from 'moment'

const validateBudget = (newBudget, objectiveDailyBudget, campaignStartDate, campaignEndDate = null) => {

  let minBudget = objectiveDailyBudget,
    isValidBudget = false

  if (campaignEndDate) {
    const dateFormat = 'YYYY-MM-DD'
    const now = moment(new Date()).format(dateFormat)
    const startDate = moment(campaignStartDate, dateFormat)
    const dateToCalcRemainingDays = moment(startDate, dateFormat).isAfter(now) ? moment(startDate) : now

    const campaignWorkingDays = moment(campaignEndDate).diff(dateToCalcRemainingDays, 'days') + 1

    minBudget = objectiveDailyBudget * campaignWorkingDays
  }

  if (+newBudget >= +minBudget) {
    isValidBudget = true
  }

  return {
    minBudget,
    valid: isValidBudget,
    msg: `The minimum ${campaignEndDate ? '' : 'daily'} budget has to be $${ minBudget } or more.`
  }
}

export default validateBudget
